import axios from 'axios'
import { risQScores } from './risq_score'
import chroma from 'chroma-js'

export async function deleteAtRoute(route, id){

    return await axios.put(process.env.VUE_APP_API_HOST + '/' + route + '/' + id, {

      is_deleted: true

    }
    )
  }

  // methods bypassing the fact that sessionStorage only stores strings

  export const get = (string) => JSON.parse(sessionStorage.getItem(string))

  export const set = (key, arr) => sessionStorage.setItem(key, JSON.stringify(arr))

  export function isHigh(time, category, scores){
  return scores[time][category] > risQScores.orangePoint
}

let prepare = ( a, color) => chroma(color).alpha(a).saturate(5).hex()

function backgroundStyle(color, angle='104deg', rhStart='93%'){
let alpha = (a) => prepare(a, color)

    return  `linear-gradient(${angle}, ${alpha(0)} 0.9%, ${alpha(1.25)} 2.4%, ${alpha(0.5)} 5.8%, ${alpha(0.1)} ${rhStart}, ${alpha(0.7)}, ${alpha(0)} 98%), linear-gradient(183deg, ${alpha(0)} 0%, ${alpha(0.3)} 7.9%, ${alpha(0)} 15%);`
}
function shadowStyle(color){
    let alpha = (a) => prepare(a, color)
   return `-12px 12px 9.8px ${alpha(0.7)}, 21px -18.1px 7.3px rgba(255, 255, 255,1), -18.1px -27.3px 30px rgba(255, 255, 255,1);`
   }

function clipStyle(topLeft, bottomRight){
     return` -webkit-clip-path: polygon(${topLeft} 0, 100% 0%, ${bottomRight} 100%, 0% 100%);
clip-path:polygon(${topLeft} 0, 100% 0%, ${bottomRight} 100%, 0% 100%);`
}

function widthStyle(width){

    return `width: ${width};`
}

export function highlight(color, width='auto', topLeft=0, bottomRight='100%', angle='104deg', rhStart='93%', bold=false){

    let style = `background: ${backgroundStyle(color, angle, rhStart)}
    padding: 5px 10px;
    -webkit-box-decoration-break: clone;
    margin: 0;
    border-radius:15%;

    text-shadow: ${shadowStyle(color)}`.concat(clipStyle(topLeft, bottomRight)).concat(widthStyle(width))

return bold? style.concat(`font-weight:bold;`): style
}
//7.5px;
